const types = {
    INTELLIGENCE_FORMS_GET_DATA: 'INTELLIGENCE_FORMS_GET_DATA',
    INTELLIGENCE_FORMS_GET_DATA_BY_ID: 'INTELLIGENCE_FORMS_GET_DATA_BY_ID',
    INTELLIGENCE_FORMS_STORE_DATA: 'INTELLIGENCE_FORMS_STORE_DATA',
    INTELLIGENCE_FORMS_STORE_FORM_DATA: 'INTELLIGENCE_FORMS_STORE_FORM_DATA',
    INTELLIGENCE_FORMS_SAVE_DATA: 'INTELLIGENCE_FORMS_SAVE_DATA',
    INTELLIGENCE_FORMS_CHANGE_STATUS_FORM: 'INTELLIGENCE_FORMS_CHANGE_STATUS_FORM',
    INTELLIGENCE_FORMS_DELETE_DATA: 'INTELLIGENCE_FORMS_DELETE_DATA',
    INTELLIGENCE_FORMS_CLEAR_MESSAGES: 'INTELLIGENCE_FORMS_CLEAR_MESSAGES'
}

export default types;

export const getData = (formId) => {
    return { type: types.INTELLIGENCE_FORMS_GET_DATA, payload: { formId } };
}

export const getDataById = (formId, id) => {
    return { type: types.INTELLIGENCE_FORMS_GET_DATA_BY_ID, payload: { formId, id } };
}

export const storeData = (formId, data) => {
    return { type: types.INTELLIGENCE_FORMS_STORE_DATA, payload: { formId, data } };
}

export const storeFormData = (formId, data) => {
    return { type: types.INTELLIGENCE_FORMS_STORE_FORM_DATA, payload: { formId, data } };
}

export const saveData = (values, formId) => {
    return { type: types.INTELLIGENCE_FORMS_SAVE_DATA, payload: { values, formId } };
}

export const deleteData = (id, formId) => {
    return { type: types.INTELLIGENCE_FORMS_DELETE_DATA, payload: { id, formId } };
}

export const changeStatus = (formId, data) => {
    return { type: types.INTELLIGENCE_FORMS_CHANGE_STATUS_FORM, payload: { formId, data } };
}

export const clearMessages = () => {
    return { type: types.INTELLIGENCE_FORMS_CLEAR_MESSAGES };
}
